var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    class: {
      'grey lighten-2': _vm.dragover
    },
    attrs: {
      "hover": ""
    },
    on: {
      "drop": function ($event) {
        $event.preventDefault();
        return _vm.onDrop($event);
      },
      "dragover": function ($event) {
        $event.preventDefault();
        _vm.dragover = true;
      },
      "dragenter": function ($event) {
        $event.preventDefault();
        _vm.dragover = true;
      },
      "dragleave": function ($event) {
        $event.preventDefault();
        _vm.dragover = false;
      }
    }
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "multiple": ""
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _c('v-card-text', {
    staticClass: "py-3 px-0",
    staticStyle: {
      "overflow": "hidden"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.file.click();
      }
    }
  }, [_vm.uploadedFiles.length === 0 ? _c('div', {
    staticClass: "d-flex flex-column align-center justify-center text-center px-4"
  }, [_c('v-icon', {
    staticClass: "mb-1"
  }, [_vm._v("mdi-cloud-upload")]), _c('span', {
    staticClass: "text-body-2"
  }, [_vm._v(_vm._s(_vm.text))])], 1) : _vm._e(), _vm._l(_vm.uploadedFiles, function (item) {
    return _c('v-list-item', {
      key: item.name
    }, [_c('v-list-item-content', {
      staticClass: "px-0 py-0"
    }, [_c('v-list-item-title', [_vm._v(" " + _vm._s(item.name) + " "), _c('span', {
      staticClass: "ml-1 text--secondary"
    }, [_vm._v(" " + _vm._s(item.size) + " bytes")])])], 1), _c('v-list-item-action', {
      staticClass: "my-0"
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.removeFile(item.name);
        }
      }
    }, [_c('v-icon', [_vm._v(" mdi-close-circle")])], 1)], 1)], 1);
  })], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }